import { THEME_KEY } from "@/contants";
import type { ThemeProps } from "@/store";
import { getCurrentInstance } from 'vue'

export default (theme: ThemeProps, register = true) => {
  const app = getCurrentInstance()
  const { $vistra } = app!.appContext.config.globalProperties
  const html = document.querySelector("html");

  if (html) {
    if (theme === "dark" && !html.classList.contains("dark"))
      html.classList.add("dark");

    if (theme === "light" && html.classList.contains("dark"))
      html.classList.remove("dark");
  }

  if (register) $vistra.Contexto.setLocalStorageItem(THEME_KEY, theme);
};
